__turbopack_context__.v({
  "addressName": "qTnJqW_addressName",
  "buttonsWrapper": "qTnJqW_buttonsWrapper",
  "icon": "qTnJqW_icon",
  "summaryWrapper": "qTnJqW_summaryWrapper",
  "triggerWrapper": "qTnJqW_triggerWrapper",
});
